/* eslint-disable prettier/prettier */
module.exports = function (isMobile, locale) {
  return {
    navList: [{
      name: '48V全场景电源系统',
      imgSrc: isMobile ? ['solutions_nav_mm100_h5.webp', 'solutions_nav_mm100_h5.jpg'] : ['solutions_nav_mm100.webp', 'solutions_nav_mm100.jpg'],
      detLink: "/".concat(locale, "/ecoflow-power-kits/series")
    },
    /**
     * @desc cn 站无 Components
     */
    {
      name: 'Components',
      icons: '',
      // detLink: `https://${locale}.ecoflow.com/collections/power-kits-components`,
      detLink: null
    }, {
      name: '定制您的电源系统',
      icons: '',
      detLink: "/".concat(locale, "/calculators/power-kits"),
      target: '_blank'
    }],
    content: {
      headerData: [{
        type: 'large',
        name: '48V 全场景电源系统',
        desc: '化繁为简 安全加码 智能生态',
        imgSrc: isMobile ? ['solutions_bg_h5_cn.webp', 'solutions_bg_h5_cn.jpg'] : ['solutions_bg_cn.webp', 'solutions_bg_cn.jpg'],
        detLink: "/".concat(locale, "/ecoflow-power-kits/series")
      }],
      /**
       * @desc cn 站无 contextList
       */
      contextList: [{
        type: 'small',
        name: '智控五合一充逆一体机',
        desc: '集成五大模块',
        imgSrc: isMobile ? ['solutions_list1_h5_cn.webp', 'solutions_list1_h5_cn.jpg'] : ['solutions_list1_cn.webp', 'solutions_list1_cn.jpg'],
        imgHoverSrc: ['solutions_list1_hover_cn.webp', 'solutions_list1_hover_cn.jpg'],
        // detLink: `https://${locale}.ecoflow.com/products/power-hub`,
        detLink: null
      }, {
        type: 'small',
        name: '磷酸铁锂电池',
        desc: '2-15度电大容量',
        imgSrc: isMobile ? ['solutions_list2_h5.webp', 'solutions_list2_h5.jpg'] : ['solutions_list2.webp', 'solutions_list2.jpg'],
        imgHoverSrc: ['solutions_list2_hover.webp', 'solutions_list2_hover.jpg'],
        // detLink: `https://${locale}.ecoflow.com/products/lfp-battery`,
        detLink: null
      }, {
        type: 'small',
        name: '智能配电盒',
        desc: '6路交流及12路直流控制',
        imgSrc: isMobile ? ['solutions_list3_h5.webp', 'solutions_list3_h5.jpg'] : ['solutions_list3.webp', 'solutions_list3.jpg'],
        imgHoverSrc: ['solutions_list3_hover.webp', 'solutions_list3_hover.jpg'],
        // detLink: `https://${locale}.ecoflow.com/products/ac-dc-smart-distribution-panel`,
        detLink: null
      }, {
        type: 'small',
        name: '智触监控屏',
        desc: '控制和查看您的功耗',
        imgSrc: isMobile ? ['solutions_list4_h5_cn.webp', 'solutions_list4_h5_cn.jpg'] : ['solutions_list4_cn.webp', 'solutions_list4_cn.jpg'],
        imgHoverSrc: ['solutions_list4_hover_cn.webp', 'solutions_list4_hover_cn.jpg'],
        // detLink: `https://${locale}.ecoflow.com/products/power-kits-console`,
        detLink: null
      }]
    }
  };
};